import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton,
  InstapaperShareButton,
} from 'react-share';
import './styles.scss';
import 'font-awesome/css/font-awesome.min.css';


const shareMap: any = {
  facebook: FacebookShareButton,
  twitter: TwitterShareButton,
  pinterest: PinterestShareButton,
  instagram: InstapaperShareButton,
};

const SocialShare: React.FC<any> = ({ title, titleFontColor, icons }) => {
  const filteredIcons = icons.filter((icon: any) => {
		let socialmedia_ = icon.socialMedia;

		return (socialmedia_ in shareMap);
  });
  return (
    <div className="social-share">
      <div className="container">
        <div className="row">
          <div className="title col-12">
            <h1 style={{color: titleFontColor}}>{title}</h1>
          </div>
          <div className="share-buttons col-12">
					  {filteredIcons.map((icon: any, i: number) => {
              const ShareButton = shareMap[icon.socialMedia];
              return (
                <span className="share-button" key={`share-button-${i}`}>
                  {icon.socialMedia == "pinterest" ?
                    <a target="_blank" href={ icon.link === "#" ? "https://pinterest.com/pin/create/button/?url="+ window.location.origin + window.location.pathname +"&description=" +icon.text : "https://pinterest.com/pin/create/button/?url="+ icon.link +"&description=" +icon.text  }>
                      <>
                        { icon.iconType==="font_awesome" ?
                        <i className={icon.fontAwesomeClass + " " + icon.socialMedia} style={{color: icon.fontAwesomeIconColor}}/>
                        : <img src={icon.svgCode} alt={"code"}/>
                        }
                      </>
                    </a>
                    : icon.socialMedia == "twitter" ?
                      <a target="_blank" href={ icon.link === "#" ? "https://twitter.com/share?source=tweetbutton&text="+ icon.text +"&url="+ window.location.origin + window.location.pathname: "https://twitter.com/share?source=tweetbutton&text="+ icon.text +"&url="+ icon.link}>
                        <>
                          { icon.iconType==="font_awesome" ?
                          <i className={icon.fontAwesomeClass + " " + icon.socialMedia} style={{color: icon.fontAwesomeIconColor}}/>
                          : <img src={icon.svgCode} alt={"code"}/>
                          }
                        </>
                      </a>
                    : icon.socialMedia == "instagram" ?
                      <a target="_blank"
                         href={icon.link === "#" ? "https://www.instagram.com/?url=" + window.location.origin + window.location.pathname : "https://www.instagram.com/?url=" + icon.link}>
                        <>
                          {icon.iconType === "font_awesome" ?
                            <i
                              className={icon.fontAwesomeClass + " " + icon.socialMedia}
                              style={{color: icon.fontAwesomeIconColor}}/>
                            : <img src={icon.svgCode} alt={"code"}/>
                          }
                        </>
                      </a>
                    :
                      <a target="_blank" href={ icon.link === "#" ? "https://www.facebook.com/sharer.php?u="+ window.location.origin + window.location.pathname: "https://www.facebook.com/sharer.php?u="+ icon.link}>
                        <>
                          { icon.iconType==="font_awesome" ?
                          <i className={icon.fontAwesomeClass + " " + icon.socialMedia} style={{color: icon.fontAwesomeIconColor}}/>
                          : <img src={icon.svgCode} alt={"code"}/>
                          }
                        </>
                      </a>
                  }
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialShare;
